///<reference types="../@types/global" />
import "./ErrorHandling.js";
import "../Helpers/Time.js";
import "../Helpers/Urls.js";
import "../Helpers/DOM.js";
import '../Helpers/Colors.js';
import '../Helpers/ArrayHelpers.js';
import './dictionary.js';
import '../Ko/templateUtilities.js';
import '../ko/componentLoader.js';
import '../System/registerComponent.js';
import "../System/DxDefaults.js";
import di from './di.js';
import { Route, Router } from './Router.js';
import { createViewModel, bind, async, value } from '../Ko/ViewModelHelpers.js';
import { getOne, isEventInElement } from "../Helpers/DOM.js";
import { DataResult } from "../Models/DataResult.js";
import { currentDocument } from "../Models/CurrentDocument.js";
import { uploadModel } from "../Models/UploadModel.js";
import { getErrorBindingProvider } from "../Ko/ErrorBindingProvider.js";
import { notificationModel } from "../Models/NotificationModel.js";
import { to } from "../Helpers/Utilities.js";
import { Events } from "../Helpers/Event.js";
import { createTippyWithComponent } from "../Dialog/tippyWithComponent.js";
import { SessionTimeoutManager } from '..//System/SessionTimeout.js';
import { folders } from "../Models/Folders.js";
import { closeAllOverflowMenus } from "../Dialog/overflow.js";
import { toastMessage } from "../Dialog/dialog.js";
import { Xtendis } from "../@types/Xtendis.js";


di.singleton('dialogZIndex', () => {

    //date-control popup start with 1500, so must be lower
    let zIndex = 1000;

    return {
        get() {     
            zIndex++
            return zIndex;
        }
    }
})

di.transient('_ko', function () {

    console.log('Click an element to get it\'s bounded data.')
    return new Promise(res => {
        const dispose = Events.add(document, 'click', (e) => {
            const el = ko.dataFor(e.target)

            res(el);
            //console.log(el);

            dispose();
        })
    })
})

di.transient('Formfactor', function () {

    return (window.outerWidth < 400) ?
        'phone'
        :
        (window.outerWidth < 900)
            ?
            'tablet' :
            'desktop';
})

di.transient('_ko2', function () {
    return new Promise(res => {
        const pack = Events.Pack();
        let el = null;
        let tippy = null;

        toastMessage({
            timeout: 90000,
            icon: 'icon-bug',
            color: 'var(--x10-purple)',
            description: 'Right-click elements to see the bounded data, use a "double-click" to close.'
        })

        pack.on(document, 'contextmenu', (e) => {
            const _el = document.elementFromPoint(e.clientX, e.clientY);

            const mouseInTippy = (el?._tippy?.popper) ?
                isEventInElement(e, el._tippy.popper, 10) :
                false;

            if (_el !== el && !mouseInTippy) {
                _el?.classList?.add('__ko-debug');

                el?.classList?.remove('__ko-debug');

                el?._tippy?.destroy()
                const data = ko.dataFor(_el);

                if (data) {
                    tippy = createTippyWithComponent(_el,
                        'jsonviewer',
                        { Data: data, fontSize: '75%' },
                        {
                            delay: [400, 150],
                            theme: 'material',
                            popperOptions: {
                                modifiers: [
                                    {
                                        name: 'preventOverflow',
                                        options: {
                                            clippingParents: 'none',
                                            rootBoundary: 'viewport',
                                            altAxis: true,
                                        }
                                    },
                                ]
                            },
                        },
                    );
                }
                el = _el;
            }

            e.preventDefault();
            return false;
        });

        pack.on(document, 'dblclick', (e) => {

            toastMessage({
                icon: 'icon-bug',
                color: 'var(--x10-purple)',
                description: 'Mode is closed'
            })

            const data = ko.dataFor(e.target);

            res(data)
            pack.off();
            el?.classList?.remove('__ko-debug');
            el?._tippy?.destroy();
            setTimeout(tippy.hideAll, 500);
            setTimeout(tippy.hideAll, 1500);
            setTimeout(tippy.hideAll, 3000);


        })

        //const dispose = Events.add(document, 'mouseover', (e) =>
        //{
        //    const el = ko.dataFor(e.target)
        //    e.target.classList.add('__ko-debug')

        //    res(el);
        //    //console.log(el);

        //    dispose();
        //})
    })
})

di.singleton('Navigation', function () {

    return createViewModel({
        props: {
            value: async(() => x10.navigation.main(), {})
        }
    })
})

di.singleton('Users', function () {
    return createViewModel({
        props: {
            value: async(() => x10.user.all(), [])
        }
    })
});

di.transient('Route', function (Router) {

    const route: Route = Router.getCurrentRoute();
    if (!route) console.warn('No current route available!')

    const params = route.params ?? {};
    const subscriptions = Object
        .keys(params)
        .reduce(function (subscriptions, key) {
            //voeg voor elke parameter een subscriptie toe
            subscriptions[key] = (paramValue) => {
                //update params:
                params[key] = paramValue;
                Router.updateCurrentRoute(route, route.params);

            }
            return subscriptions
        }, {})

    if (route.params) {
        return createViewModel({
            props: route.params,
            subscribe: subscriptions
        });
    }

    return route.params;

});

di.singleton('Notification', notificationModel)

di.singleton('Clipboard', function () {
    return createViewModel({
        props: {
            pages: [],
            isPinned: false
        },
        methods: {
            showAndHide: function () {
                this.isPinned = true;
                setTimeout(() => this.isPinned = false, 2000)
            }
        }
    });
})

di.singleton('CurrentDossier', function () {

    return createViewModel({
        props: {
            isLoading: false,
            value: null,
            properties: [],
            error: '',
            info: null
        },
        methods: {
            refresh: function () {
                if (!this.value) {
                    console.warn('Cannot refresh, there is no dossier yet')
                    return null;
                }

                return this.load(this.value.Archiefid, this.value.ID);
            },
            load: async function (archiveId, dossierId) {
                //gaat zo snel, dat loading bar alleen maar knippert
                //this.isLoading = true;

                const { result, error } = await x10.dossier.getInfo<any>(archiveId, dossierId);

                //this.isLoading = false;

                this.value = result?.Dossier;
                this.info = result?.Info;
                this.properties = result?.Properties.sortProp('VisibleIndex')


                this.error = error ?? '';
            },
            clear: function () {
                this.isLoading = false;
                this.value = null
                this.properties = [];
                this.info = null;

                this.error = '';
            }
        }
    })
})

di.singleton('PageOrderCounter', function () {
    return createViewModel({
        props: {
            value: 1,
            isChecked: false
        },
        methods: {
            reset: function () {
                this.value = 1;
                this.isChecked = false;
            }
        }
    })
});

di.singleton('ShareDocument', function () {
    return createViewModel({
        props: {
            pagenumber: 1,
            isLoading: false,
            value: null,
            error: '',
            signature: null,
            info: null
        },
        methods: {
            refresh: function () {
                if (!this.value) {
                    console.warn('Cannot refresh, there is no document yet')
                    return null;
                }

                return this.load(this.value.GedeeldDocumentGuid);
            },
            load: async function (documentdeelInfoGuid = '') {
                this.isLoading = true;
                const [{ result, error }, deelInfo] = await Promise.all([
                    x10.share.getSharedDocument<any>(documentdeelInfoGuid),
                    x10.document.getDocumentDeelInfo<any>(documentdeelInfoGuid)]);

                let data;
                if (!error && result?.TekenStatus) {
                    data = await x10.share.getSignature(documentdeelInfoGuid);
                }
                this.isLoading = false;
                this.value = result;
                this.pagenumber = 1;
                this.error = error ?? '';
                this.signature = data?.result;
                this.info = deelInfo.result;

            },
            clear: function () {
                this.isLoading = false;
                this.value = null;
                this.pagenumber = 1;
                this.error = '';
                this.signature = null;
                this.info = null;
            }
        }
    })
});

di.singleton('CurrentDocument', currentDocument);

di.singleton('Folders', folders);

di.singleton('Upload', uploadModel);

di.singleton('Archives', function () {


    return createViewModel({
        props: {
            all: async(() => x10.archive.allWithPermissions(), [])
        }
    })
});

di.singleton('DefaultArchive', function (Archives) {
    //TODO check if localstorage values still apply
    return createViewModel({
        props: {
            all: bind(Archives, 'all'),
            value: function () {
                return this.all.find(i => i.ID === Number(this.id));
            },
            indexArchive: function () {
                return this.all.find(i => i.ID === Number(this.indexId));
            },
            dossierArchive: function () {
                return this.all.find(i => i.ID === Number(this.dossierId));
            },
            id: X10SESSION.SearchDocumentsArchiveId,
            indexId: X10SESSION.IndexDocumentArchiveId,
            dossierId: X10SESSION.SearchDossiersArchiveId
        },
        methods: {
            setById: function (id) {
                this.id = id;
            }
        },
        subscribe: {
            id: function (id) {
                x10.archive.setDefaultSearchArchive(id);
            }
        },
        localStore: {
            key: 'DefaultArchive',
            props: []
        }
    });
})

di.singleton('NoteResult', function () {
    return createViewModel({
        props: {
            isLoading: false,
            result: value<Array<Xtendis.Notitie>>([])
        },
        methods: {
            clear() {
                this.result = [];
            }
        }
    })
})

di.singleton('SelectDossierResult', DataResult)

di.singleton('DossierResult', DataResult)

di.singleton('DocumentResult', DataResult)

di.singleton('Router', Router)

di.singleton('Root', function() {

    return createViewModel({
        props: {
            isLoading: true,
            page: null
        },
        methods: {
            async    navigate (page, params) {

                this.isLoading = true

                closeAllOverflowMenus();

                const data = await x10.misc.getSession()

                this.isLoading = false

                if (data.isLoggedOut) {

                    const url = x10.getBaseUrl() + '/logon.aspx?httpRef=' + encodeURIComponent(window.location.href);
                    window.location.href = url;

                }
                //vergelijking van params zou niet hoeven, 
                //omdat via Route object verteld kan worden dat de params zijn veranderd
                //echter werken niet alle pagina's daar goed op;
                if (this.page?.name !== page ||
                    JSON.stringify(this.page.params) !== JSON.stringify(params)) {
                    this.page = {
                        name: page,
                        params: params
                    }
                }
            }
        }
    });
});

//load register of components, needs the Router
const registerUrl = '../register.js'

const registration = import(registerUrl);

const bootstrap = async function () {

    try {
        //logged out if x10 is not defined or when it is defined, it returns loggedOut.
        await dict.setLang(X10SESSION.Culture);

        const baseUrl = ('x10' in window) ? x10.getBaseUrl() : window.location.href;

        const isLoggedOut =
            !('x10' in window) ||
            (await x10.misc.getSession()).isLoggedOut;

        const applicationCode = X10SESSION?.Context || 'Web';

        if (isLoggedOut) {
            window.location.href = baseUrl + '/logon.aspx?httpRef=' + encodeURIComponent(window.location.href); + '&applicationCode=' + applicationCode;
            return;
        }

        const root = di.resolve<any>('Root');

        root.isLoading = false;
        document.querySelector('#splash')?.remove();

        getOne('.dashboard-main').style.display = 'block';

        //als er geen route is, ga dan naar 'home'
        if (!window.location.hash)
            window.location.hash = 'home'

        ko.options.deferUpdates = true;
        ko.punches.enableAll();
        ko.bindingProvider.instance = <any>getErrorBindingProvider();

        ko.applyBindings(root);

        di.resolve<any>('Router').init((name, params) => {
            root.navigate(name, params)
        });

        //trigger request, otherwise they will get loaded only when needed (could be too late)
        if (window?.X10SESSION?.Context !== 'DocumentDelen') {
            const archives = di.resolve('Archives').all
        }


        if (window.location.href === window.top.location.href) {
            SessionTimeoutManager.scheduleTimeoutPopup();

            //home heeft auto-update van map-counts
            if (('x10' in window) && x10.globalCallback) {
                x10.globalCallback(SessionTimeoutManager.scheduleTimeoutPopup);
            }
        }

        const [registration, error] = await to(
            navigator.serviceWorker.register(x10.getBaseUrl() + 'serviceworker.js'));

        if (error) console.warn(error);

        await navigator.serviceWorker.ready;
    } catch (err) {
        console.log(err);
        alert('Something went wrong in startup phase.' + err);
    }

}

Promise.all([registration])
    .then(bootstrap);


